import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import AuthWrapper from 'components/AuthWrapper';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import identityClient from 'clients/identityClient';

const PhoneAsLogin = () => {
  const location = useLocation();
  const history = useHistory();
  const { phone, accountData } = location.state || {};
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      if (selectedOption === 'yes') {
        await identityClient.SetAlias(accountData.hstreamId, 'phone', phone);
        history.push({
          pathname: '/phonePromptSuccess',
          search: window.location.search,
        });
        return;
      }

      if (localStorage.getItem('isMobilePrompt') == 1) {
        localStorage.setItem('isMobilePrompt', 0);
        const url = localStorage.getItem('oAuthRedirectUrl');
        window.location.assign(url);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthWrapper title="Login with your Mobile Number">
      <div
        className="position-relative"
        aria-busy={isLoading || undefined}
      >
        <BlockingSpinnerOverlay show={isLoading} ariaLabel="Loading..." />
        <p>
          Would you like to use your Mobile Number as an alternative login method
          for hStream?
        </p>

        <FormGroup tag="fieldset" className="pl-4">
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="phoneLogin"
                value="yes"
                checked={selectedOption === 'yes'}
                disabled={isLoading}
                onChange={() => setSelectedOption('yes')}
              />{' '}
              Yes
            </Label>
          </FormGroup>
          <FormGroup check className="py-3">
            <Label check>
              <Input
                type="radio"
                name="phoneLogin"
                value="no"
                checked={selectedOption === 'no'}
                disabled={isLoading}
                onChange={() => setSelectedOption('no')}
              />{' '}
              No
            </Label>
          </FormGroup>
        </FormGroup>

        <Button
          color="primary"
          block
          onClick={handleContinue}
          disabled={!selectedOption || isLoading}
        >
          Continue
        </Button>
      </div>
    </AuthWrapper>
  );
};

PhoneAsLogin.propTypes = {
  phone: PropTypes.string.isRequired,
};

export default PhoneAsLogin;
